import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { LasuiteChangePasswordSentComponent } from './lasuite-change-password-sent/lasuite-change-password-sent.component';
import { LasuiteForgotPasswordComponent } from './lasuite-forgot-password/lasuite-forgot-password.component';
import { LasuiteInputComponent } from './lasuite-input/lasuite-input.component';
import { LasuiteLoginComponent } from './lasuite-login/lasuite-login.component';
import { LasuiteOemHeaderComponent } from './lasuite-oem-header/lasuite-oem-header.component';
import { LasuiteOemLoginMessageComponent } from './lasuite-oem-login-message/lasuite-oem-login-message.component';
import { LasuiteOemRegisterMessageComponent } from './lasuite-oem-register-message/lasuite-oem-register-message.component';
import { LasuitePasswordInputComponent } from './lasuite-password-input/lasuite-password-input.component';
import { LasuiteRegisterResendComponent } from './lasuite-register-resend/lasuite-register-resend.component';
import { LasuiteRegisterSendComponent } from './lasuite-register-send/lasuite-register-send.component';
import { LasuiteRegisterModule } from './lasuite-register/lasuite-register.module';
import { LasuiteResetPasswordComponent } from './lasuite-reset-password/lasuite-reset-password.component';
import { LasuiteUnblockComponent } from './lasuite-unblock/lasuite-unblock.component';
import { LasuiteComponent } from './lasuite/lasuite.component';
import { OemService } from './oem.service';
import { PulldownModule } from './pulldown/pulldown.module';

@NgModule({
  declarations: [
    LasuiteComponent,
    LasuiteLoginComponent,
    LasuiteUnblockComponent,
    LasuiteRegisterResendComponent,
    LasuiteRegisterSendComponent,
    LasuiteForgotPasswordComponent,
    LasuiteResetPasswordComponent,
    LasuiteChangePasswordSentComponent,
    LasuiteInputComponent,
    LasuitePasswordInputComponent,
    LasuiteOemHeaderComponent,
    LasuiteOemRegisterMessageComponent,
    LasuiteOemLoginMessageComponent,
  ],
  imports: [
    // 各コンポーネントの共有モジュール。ページごとにモジュールを作るほうが保守性は向上する。
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
    PulldownModule,
    // モジュール化したページの利用を宣言
    LasuiteRegisterModule,
  ],
  exports: [
    LasuiteResetPasswordComponent,
    LasuiteComponent,
    LasuiteRegisterResendComponent,
    LasuiteRegisterSendComponent,
    LasuiteUnblockComponent,
    LasuiteChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LasuiteModule {}
